module.exports = {"350922001":"城东街道","350922002":"城西街道","350922101":"平湖镇","350922102":"大桥镇","350922103":"黄田镇","350922104":"鹤塘镇","350922105":"杉洋镇","350922106":"凤都镇","350922107":"水口镇","350922108":"大甲镇","350922201":"吉巷乡","350922203":"泮洋乡","350922204":"凤埔乡","350922205":"卓洋乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350922.json
// module id = 1239
// module chunks = 0